
import { mapGetters, mapState, mapActions } from 'vuex'
import Closable from './Closable'
import ConnectIcon from '~/assets/connect.svg'
import CloseIcon from '~/assets/close.svg'
import CollectIcon from '~/assets/collect.svg'
import CreateIcon from '~/assets/create.svg'
import ExperienceIcon from '~/assets/experience.svg'
import SettingsIcon from '~/assets/settings.svg'
import ProfilePlaceholder from '~/assets/profile-placeholder.svg'
import { getCID } from '~/utils/helpers'

export default {
  name: 'OptionsMenu',
  components: {
    ConnectIcon,
    CloseIcon,
    ProfilePlaceholder,
    CollectIcon,
    CreateIcon,
    ExperienceIcon,
    SettingsIcon,
  },
  mixins: [Closable],
  computed: {
    ...mapGetters(['synced', 'bgColor', 'textColor', 'secondaryColor', 'walletAddress', 'canMint']),
    ...mapState('currentUserProfile', ['profile', 'dashes']),
    avatar() {
      if (this.profile?.avatar) {
        const cid = getCID(this.profile.avatar)
        return `https://ipfs-imgix.ebo.io/ipfs/${cid}?ar=1:1&fit=crop&w=200&h=200&auto=format&lossless=1`
      }
      return ''
    },
  },
  watch: {
  },
  methods: {
    ...mapActions(['initWallet']),
    unsync() {
      this.$router.push('/discover')
      this.$store.dispatch('unsync')
    },
    handleMaybeLinkClick(e) {
      if (e.target.tagName === 'A' || e.target.closest('a')) {
        this.$emit('close')
      }
    }
  },
}
